<!-- Add "scoped" attribute to limit CSS to this component only -->
<template>
	<div>
		<div class="goodsImg_div column aifs pt8">
			<!-- <p style="color: #a1a7b2">{{ $t("可直接贴图或拖拽上传图片") }}</p> -->

			<div class="row">
				<p
					class="image-num mr10"
					v-if="showLength != 0 && image.length > showLength"
					@click="lookImageClick(image, !showStatus, detailTitle || $t('查看图片'))"
				>
					+{{ image.length - showLength }}
				</p>
				<div class="column aic image_scroll mr8" :class="showUpload ? '' : 'is_hidden'">
					<!-- 拖拽/粘贴 -->
					<div
						tabindex="0"
						class="drag column aic jcc"
						:style="{
							borderColor: is_focus ? '#2c68ff' : '#D4D8E1',
							width: width,
							height: height || width,
							background: `#f6f7fa`
						}"
						@click="uploadClick"
						ref="upload"
					>
						<span style="line-height: 20px">{{ $t("粘贴/拖拽") }}</span>
						<span style="line-height: 20px">{{ $t("上传图片") }}</span>
						<input ref="fileIpt" class="filePaste-ipt" @focus="focusChange(true)" @blur="focusChange(false)" />
					</div>

					<el-upload
						accept="image/jpeg,image/png"
						multiple
						:limit="limit"
						class="upload-demo"
						:show-file-list="false"
						:on-exceed="handleExceed"
						:file-list="file_image()"
						name
						list-type="picture"
						action
						:http-request="($event) => handleUpload($event, image, limit)"
						:before-upload="
							($event) => {
								return beforeAvatarUpload($event, ['image/jpeg', 'image/png'], size, {
									data: image,
									limit: limit
								});
							}
						"
					>
						<div class="row" style="font-size: 12px; color: #2c68ff; line-height: 18px">
							{{ $t("点击上传") }}
						</div>
					</el-upload>
				</div>
				<div class="row aic fww flex1" v-if="!noShowImage">
					<template v-for="(item, index) in image">
						<div
							class="item_div"
							:style="{
								width: width,
								height: height,
								padding: 0
							}"
							:key="index"
							v-if="showLength == 0 || index + 1 <= showLength"
						>
							<!-- 删除图标 -->
							<template v-if="!item[deleteKey] || item[deleteKey] == code_status">
								<i
									class="iconfont icon-error"
									:style="{ fontSize: iconFontSize, right: iconRight, top: iconTop }"
									@click="deleteImg(index, item)"
									v-if="!disabled"
								></i>
							</template>

							<!-- 已录状态 -->
							<p
								class="image-status"
								:style="{
									backgroundColor: item[statusKey] == 1 ? '#00B42A' : '#2C68FF'
								}"
								v-if="showStatus"
							>
								{{ item[statusKey] == 1 ? $t("已录") : $t("未录") }}
							</p>
							<el-image
								class="img_div"
								:src="(item instanceof Object ? item[imgKey] : item) + '?x-oss-process=style/sytle_order'"
								:style="{ width, height }"
								:preview-src-list="(image || []).map((i) => (i instanceof Object ? i[imgKey] : i))"
								:initial-index="index"
							/>
						</div>
					</template>
				</div>
			</div>
		</div>

		<!-- 查看码单 -->
		<lookImage v-if="image_data.show" :data="image_data" @change="imgChange" />
	</div>
</template>
<script>
import lookImage from "./components/lookImage";
import { uploadFileToOss, beforeAvatarUpload } from "@/utils";
// import md5 from "js-md5";
// const OSS = require("ali-oss");
export default {
	components: {
		lookImage
	},
	props: {
		accept: {
			type: Array,
			default() {
				return [];
			}
		},
		// 假上传点击
		falseUpload: {
			type: Boolean,
			default() {
				return false;
			}
		},
		uploadText: {
			type: String,
			default() {
				return this.$t("点击上传图片");
			}
		},
		// 限制尺寸大小(兆)
		size: {
			type: Number,
			default() {
				return 10;
			}
		},
		//限制上传张数
		limit: {
			type: Number,
			default() {
				return 100;
			}
		},
		width: {
			type: String,
			default() {
				return "144px";
			}
		},
		height: {
			type: String,
			default() {
				return "144px";
			}
		},
		// 关闭图标尺寸
		iconFontSize: {
			type: String,
			default() {
				return "16px";
			}
		},

		// 关闭图标右边距
		iconRight: {
			type: String,
			default() {
				return "-7px";
			}
		},
		// 关闭图标上边距
		iconTop: {
			type: String,
			default() {
				return "-14px";
			}
		},
		//更多图片的标题
		detailTitle: {
			type: String,
			default() {
				return this.$t("查看图片");
			}
		},

		disabled: {
			type: Boolean,
			default() {
				return false;
			}
		},
		image: {
			type: Array,
			default() {
				return [];
			}
		},

		// 自定义上传内容
		diyContent: {
			type: Boolean,
			default() {
				return false;
			}
		},
		uploadMessageShow: {
			type: Boolean,
			default() {
				return true;
			}
		},

		// 是否展示录入状态
		showStatus: {
			type: Boolean,
			default() {
				return false;
			}
		},
		//默认展示多少张,其余用 +号表示(可点击预览) 传0表示全部展示
		showLength: {
			type: Number,
			default() {
				return 0;
			}
		},
		// 不显示所有图片
		noShowImage: {
			type: Boolean,
			default() {
				return false;
			}
		},
		// 已录状态的key
		statusKey: {
			type: String,
			default() {
				return "code_status";
			}
		},
		// 展示图片的key
		imgKey: {
			type: String,
			default() {
				return "actual_purchase_image";
			}
		},
		//用来判断当前图片的删除按钮
		code_status: {
			type: [String, Number],
			default() {
				return 0;
			}
		},
		//删除按钮的字段
		deleteKey: {
			type: String,
			default() {
				return "code_status";
			}
		},
		//bucket类型 styles: 款式图片, images: 基础图片, files: 文件
		bucketType: {
			type: String,
			default() {
				return "images";
			}
		}
	},
	computed: {
		showUpload() {
			return this.image.length < this.limit && !this.falseUpload && !this.disabled;
		}
	},
	watch: {},
	data() {
		return {
			timer: null, //定时器
			queue_arr: [], //队列
			// 查看码单
			image_data: {
				show: false,
				img_arr: []
			},
			active: false,
			is_focus: false //图片是否聚焦
		};
	},
	mounted() {
		this.createUpload();
	},
	beforeDestroy() {
		this.destroyUpload();
	},
	methods: {
		createUpload() {
			// 拖拽
			const uploadArea = this.$refs.upload;

			if (uploadArea) {
				// 绑定拖拽事件
				uploadArea.addEventListener("dragenter", this.handleDragenter);
				uploadArea.addEventListener("dragleave", this.handleDragleave);
				uploadArea.addEventListener("dragover", this.handleDragover);
				uploadArea.addEventListener("drop", this.handleDrop);

				// 绑定粘贴事件
				uploadArea.addEventListener("paste", this.handlePaste);
			}
		},
		destroyUpload() {
			const uploadArea = this.$refs.upload;

			if (uploadArea) {
				// 解绑拖拽事件
				uploadArea.removeEventListener("dragenter", this.handleDragenter);
				uploadArea.removeEventListener("dragleave", this.handleDragleave);
				uploadArea.removeEventListener("dragover", this.handleDragover);
				uploadArea.removeEventListener("drop", this.handleDrop);

				// 解绑粘贴事件
				uploadArea.removeEventListener("paste", this.handlePaste);
			}
		},
		uploadClick() {
			this.handleMouseover();
		},
		focusChange(boole) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.is_focus = boole;
			}, 200);
		},

		handleMouseover() {
			this.$refs.fileIpt.focus();
		},
		// 处理拖拽悬停
		handleDragover(e) {
			e.preventDefault(); // 必须阻止默认行为，否则 drop 事件不会触发
		},

		handleDragleave(e) {
			e.preventDefault();
			this.active = false;
		},
		handleDragenter(e) {
			e.preventDefault();
			this.active = true;
		},

		handleDrop(e) {
			e.preventDefault();
			this.active = false;
			this.handleFileName(e.dataTransfer.files);
		},

		handlePaste(e) {
			e.preventDefault();
			this.handleFileName(e.clipboardData.files);
		},

		handleFileName(fileList) {
			let files = Array.from(fileList);

			for (let i in files) {
				this.handleUpload({ file: files[i] }); //直接调用原有的图片上传
			}
		},

		file_image() {
			return (this.image || []).map((i) => {
				// 传入的图片是单一字符串时,转成对象 (单一字符串会报错)
				return i instanceof Object ? i : { url: i };
			});
		},
		// 上传队列
		async queueChange() {
			const uploadPromises = this.queue_arr.map((item) =>
				uploadFileToOss(item, this.bucketType).then((result) => {
					result.url = result.res.requestUrls[0];
					result.image_name = item.name;
					this.$emit("uploadSuccess", result, this.queue_arr.length === 1);

					return result;
				})
			);

			await Promise.all(uploadPromises);
			this.queue_arr = [];
		},
		handleExceed(files, fileList) {
			this.$message.warning(
				this.$t("当前限制选择 {slot1} 个文件，本次选择了 {slot2} 个文件，共选择了 {slot3} 个文件", {
					slot1: this.limit,
					slot2: files.length,
					slot3: files.length + fileList.length
				})
			);
		},
		handleUpload(file1) {
			this.queue_arr.push({
				file: file1.file,
				name: file1.file.name
			});
			//触发队列执行
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.queueChange();
				clearTimeout(this.timer);
			}, 500);
		},
		deleteImg(index, item) {
			this.$emit("deleteImg", index, item);
		},

		beforeAvatarUpload(file, type = [], size, obj = false) {
			return beforeAvatarUpload(file, type, size, obj);
		},

		// 查看图片
		lookImageClick(img_arr, ordinary = false, title) {
			this.image_data = {
				title,
				show: true,
				img_arr,
				ordinary,
				edit: !this.disabled, //是否可编辑
				// imgKey: "actual_purchase_image"
				imgKey: this.imgKey
			};
		},
		imgChange(is_del_index) {
			// 把数组已删除的索引传给父级
			this.$emit("change", is_del_index);
		}
	}
};
</script>
<style lang="scss" scoped>
.upload-demo {
	line-height: 20px;
}
.goodsImg_div {
	.item_div {
		position: relative;
		border: none;
		margin-right: 10px;
		margin-bottom: 10px;
		.icon-error {
			position: absolute;
			color: #2d3743;
			cursor: pointer;
			z-index: 1;
		}
	}
}
.image-num {
	margin-left: 0px;
	font-size: 12px;
	color: #2c68ff;
	cursor: pointer;
}
.img_div {
	border-radius: 4px;
}

.image-status {
	position: absolute;
	top: 4px;
	left: 0;
	color: #fff;
	height: 24px;
	line-height: 24px;
	font-size: 12px;
	padding: 0 4px;
	border-radius: 0 2px 2px 0;
	z-index: 1;
}
::v-deep .upload-demo .el-upload-dragger {
	width: auto;
	height: auto;
	border: none;
}

.image_scroll {
	border: 1px solid transparent;
	box-sizing: border-box;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.1);
	}
	&::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.05);
	}
}
.is_hidden {
	width: 0;
	height: 0;
	overflow: hidden;
	margin: 0;
}
.upload_image {
	position: relative;
	overflow: auto;
	padding-top: 10px;
	padding-right: 10px;
	.image {
		width: 58px;
		height: 58px;
		position: relative;
	}
	.icon-error {
		color: #7f8790;
		position: absolute;
		right: 3px;
		top: 1px;
		font-size: 14px;
		cursor: pointer;
	}
}
@mixin borderColor($color: #2260ff) {
	border: 1px dashed $color;
}

.drag {
	// position: absolute;
	// left: 0;
	// top: 0;
	// right: 0;
	// bottom: 0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	// pointer-events: all;
	border: 1px solid #d4d8e1;
	font-size: 11px;

	// &:hover {
	// 	@include borderColor;
	// }

	&-title {
		font-size: 14px;
	}

	&-subtile {
		width: 450px;
		font-size: 12px;
		color: #999999;
		margin-top: 0;
		text-align: center;
	}
}
.file-ipt {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	cursor: pointer;
}

.filePaste-ipt {
	position: fixed;
	right: -100vw;
	opacity: 0;
}
</style>
